import axios from 'axios';

export const createAcrsFileContainer = (containerName) =>
	axios.post('/provider_practice_file_uploads', { name: containerName });

export const uploadAcrsFile = (practiceId, file) => {
	const container = `acrs_${practiceId}_${Date.now()}`;
	return new Promise((resolve, reject) => {
		// create container
		axios
			.post('/provider_practice_file_uploads', { name: container })
			.then(() => {
				// upload file
				const url = `/provider_practice_file_uploads/${container}/upload`;
				const formData = new FormData();
				formData.append('file', file);
				const config = {
					headers: {
						'content-type': 'multipart/form-data',
					},
				};
				resolve(axios.post(url, formData, config));
			})
			.catch((err) => reject(err));
	});
};

export const uploadCleanAcrsFile = (providerId, fileData) => {
	const { sheet_id, embed_id, template_key } = fileData;

	return axios.post(`/providers/${providerId}/one-schema-export`, {
		sheet_id,
		embed_id,
		template_type: template_key,
	});
};

export const getOneSchemaToken = (providerId) =>
	axios.get(`/providers/${providerId}/one-schema-token`);

export const getOneSchemaTemplates = (providerId) =>
	axios.get(`/providers/${providerId}/one-schema-template`);

export const getACRSPatientList = (
	providerId,
	isProviderQuery = false,
	filter_options
) =>
	isProviderQuery
		? axios.post(`/providers/${providerId}/acrs-provider-list`, {
				filter_options,
		  })
		: axios.post(`/providers/${providerId}/acrs-patient-list2`, {
				filter_options,
		  });
